import React from 'react'

import HistoryItem from './history-item'

export default ({
  histories,

  hasNextPage,
  onLoadNextPage
}) => (
  <div className='list history-list'>
    {histories.map((history) =>
      <HistoryItem key={history.id} history={history} user={history.user} />
    )}

    {hasNextPage &&
      <div className='card load-more' onClick={onLoadNextPage}>
        Load more...
      </div>}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/histories/history-list.js